import { render } from "./Criterion.vue?vue&type=template&id=73a1b80e&scoped=true"
import script from "./Criterion.vue?vue&type=script&lang=js"
export * from "./Criterion.vue?vue&type=script&lang=js"

import "./Criterion.vue?vue&type=style&index=0&id=73a1b80e&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a1b80e"]])

export default __exports__